import { LocaleCode } from 'acscp/translations';

export enum LanguageState {
    Uninitialised = 0,
    SetByBrowser = 5,
    SetByUserDetails = 15,
    SetBySharingLink = 17,
    SetManually = 20
}

export interface IntlState {
    locale: LocaleCode;
    languageState: LanguageState;
}
